<template>
    <div class="services-upcoming-container" ref="container">
        <div class="columns">
            <div class="column is-4">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Upcoming Services</span>
                        <a
                                v-if="!isView && !shouldUserSelectServiceView"
                                href="#"
                                class="gear"
                                @click.prevent="isTableSettingsModalActive = true"
                        >
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                        <a
                                v-else-if="isView && currentTableView && canEditView(currentTableView.id)"
                                href="#"
                                class="gear"
                                @click.prevent="openCustomViewModal(currentTableView.id)"
                        >
                            <o-icon pack="fa" icon="edit" size="is-small"/>
                        </a>

                    </span>
                </h1>
            </div>
            <div class="column is-4 action-box">
                <div class="field is-grouped is-grouped-right">
                    <p class="control">
                        <a @click.prevent="openCustomViewModal(null)" class="button is-info"><span>Create Custom View</span></a>
                    </p>
                    <p v-if="isResetFiltersButtonVisible" class="control">
                        <a @click.prevent="resetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns custom-view-select-container">
            <div class="column">
                <o-select v-if="!filters.viewAll && table.paginated" v-model="table.perPage">
                    <option v-for="(opt, idx) in table.perPageOptions" :key="idx" :value="opt">{{opt}} per page</option>
                    <option :value="total">View all</option>
                </o-select>
            </div>
            <div class="column">
                <custom-views-filter
                        :view-id-prop="filters.table_view_id"
                        type="servicesUpcoming"
                        :handle-update="handleCustomViewChange"
                />
            </div>
            <div class="column">
                <o-field>
                    <o-select
                            v-model="services_reminder"
                            :expanded="true"
                            placeholder="Send report..."
                            @update:modelValue="handleServicesReminderChange"
                    >
                        <option value="">Send report...</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                    </o-select>
                </o-field>
            </div>
        </div>
        <div class="wrapper" v-show="!shouldUserSelectServiceView">
            <o-table
                backend-pagination
                backend-sorting
                class="services-upcoming-table fullwidth-table is-responsive is-responsive-desktop"
                v-if="isTableVisible"
                :bordered="table.bordered"
                :checkable="false"
                :data="paginatedData"
                :default-sort="table.defaultSort"
                :loading="loading"
                :mobile-cards="table.mobileCards"
                :narrowed="table.narrowed"
                :paginated="true"
                :pagination-simple="false"
                :per-page="table.perPage"
                :striped="table.striped"
                :total="total"

                :selected.sync="selected"
                :checked-rows="checkedRows"
                @update:checkedRows="$event => checkedRows = $event"

                @page-change="onPageChange"
                @sort="onSort"
            >
                <template>
                        <o-table-column
                            v-for="(col, idx) in customViewTableColumns" :key="idx + '_' + col.field"
                            :class="{ notes: col.field === 'notes_history'}"
                            :field="col.field"
                            #default="{ row }"
                            :label="col.label"
                            :sortable="col.sortable"
                        >
                            <dropdown-quick-edit
                                v-if="col.field === 'assigned_to'"
                                :entity="row"
                                field="assigned_to"
                                :update="partialUpdateProjectService"
                                :options="activeUsers"
                            />
                            <a v-else-if="col.field === 'estimated_bill_date'" href="#" @click.prevent="openEstimatedBillDateModal(row)" v-bind:class="{ required : isEstimatedBillDateInvalid(row) }">
                                {{ $filters.valueOrDefault($filters.date(row.estimated_bill_date)) }}
                            </a>
                            <span v-else-if="col.field === 'notes_history'" @click="openNotesHistoryModal(row)">
                                <ul v-if="showNote(row)">
                                    <li v-for="note in notesHistory[row.id]" :key="note.id">
                                        {{ note.value }}
                                    </li>
                                </ul>
                            </span>
                            <router-link v-else-if="col.field === 'project_id'" :to="{ name: 'projects.show', params: { slug: row.project_id } }">
                                {{ row.project_id }}
                            </router-link>
                            <router-link v-else-if="col.field === 'project_name'" :to="{ name: 'projects.show', params: { slug: row.project_id } }">
                                {{ $filters.valueOrDefault(row.project_name, '-') }}
                            </router-link>
                            <div v-else-if="col.field === 'description'">
                              <quill-editor :content-type="'html'" :content="row.description"></quill-editor>
                            </div>
                            <router-link v-else-if="col.field === 'last_editor_id'"
                                        :to="{ name: 'users.show', params: { slug: row.last_editor_id } }">
                                {{ userNameById(row.last_editor_id) }}
                            </router-link>
                            <dropdown-quick-edit
                                v-else-if="col.field === 'status'"
                                :entity="row"
                                field="status"
                                :update="handleStatusUpdate"
                                :options="projectServiceStatuses"
                                :disabled="isStatusDisabled(row)"
                            />
                            <span v-else>
                                {{ $filters.valueOrDefault(row[col.field], '-') }}
                            </span>
                        </o-table-column>
                </template>
                <template #footer>
                    <template v-for="(col, idx) in customViewTableColumns">
                        <th v-if="col.field === 'final_price'" :key="idx">
                            {{ totalsColumns.amountLabel }}
                        </th>
                        <th v-else-if="idx === 0">Totals</th>
                    </template>
                </template>
              <template #empty>
                <div class="has-text-centered">
                  This table is empty!
                </div>
              </template>
            </o-table>
           <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isEstimatedBillDateModalActive" has-modal-card>
                <service-estimated-bill-date :notesHistory="currentNotesHistory" :serviceinfo="currentService" @onSaved="handleEstimatedBillDateUpdated" />
            </o-modal>
           <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isNotesHistoryModalActive" has-modal-card>
                <notes-history-modal :projectService="currentService"/>
            </o-modal>
           <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
                <table-settings-modal :slug="tableName"/>
            </o-modal>
        </div>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isCustomViewModalActive" has-modal-card>
            <custom-view-modal
                    :custom-view="customViewToEdit"
                    :include-default-columns="true"
                    type="servicesUpcoming"
                    @custom-view-created="handleCustomViewChange"
                    @custom-view-deleted="handleCustomViewDeleted"
            />
        </o-modal>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import NotesHistoryModal from '../../../../components/modals/NotesHistoryModal'
    import ServiceEstimatedBillDate from './../../../../components/modals/ServiceEstimatedBillDate'
    import SupportsCustomViews from './../../../../mixins/SupportsCustomViews'
    import Table from './../../../../mixins/Table'
    import {QuillEditor} from "@vueup/vue-quill";

    export default {
        mixins: [ SupportsCustomViews, Table],
        components: {
          QuillEditor,
            NotesHistoryModal,
            ServiceEstimatedBillDate,
        },

        computed: {
            ...mapGetters([
                'currentProjectId',
                'isCurrentUserAdmin',
                'currentUserId',
                'currentUser',
                'projectById',
                'projectNameById',
                'projectServicesExceptOfOptionalByProjectId',
                'projectServicesPaymentsByProjectId',
                'projectServicesQuantityByProjectId',
                'projectServiceStatuses',
                'projectServicesTotalCostByProjectId',
                'userNameById',
                'users',
                'workTypeById',
                'workTypeNamesByIds',
            ]),

            activeUsers() {
                return _.filter(this.users, user => ! user.blocked)
                        .map(user => { return { id : user.id, name: user.first_name + ' ' + user.last_name } })
            },

            currentNotesHistory() {
                return this.currentService ? this.notesHistory[this.currentService.id] : []
            },

            el() { return this.$refs.container },
            
            serviceStatuses() { return [...this.projectServiceStatuses] },

            shouldUserSelectServiceView() {
                setTimeout(() => {
                  if (this.currentUser){
                    return !this.isCurrentUserAdmin && !this.currentUser.services_view
                  }
                }, 1000)
            },

            totalsColumns() {
                const data = this.items,
                currency = this.$filters.currency,
                totalsColumns = { final_price_value: 0, qty: 0 },
                perPage = this.table.perPage || 0,
                start = (this.currentPage - 1) * perPage || 0,
                end = start + perPage,
                paginated = this.table.paginated
                for (let idx = start; idx < end && idx < data.length; idx++) {
                    totalsColumns.final_price_value += data[idx].final_price_value
                }
                totalsColumns.amountLabel = currency(totalsColumns.final_price_value)
                return totalsColumns
            },
        },

        created () {
            this.filters = {
                table_view_id: null
            }
            this.$watch(() => this.table.perPage, () => {
                this.fetchPaginatedData()
            });
        },

        data() {
            return {
                currentService: null,
                filters: {
                },
                isEstimatedBillDateModalActive: false,
                isNotesHistoryModalActive: false,
                isTableSettingsModalActive: false,
                isTableVisible: true,
                items: [],
                notesHistory: {},
                selectedRow: {},
                services_reminder: 'daily',
                shouldSelectViewModalAlreadyShown: false,
                table: {
                    defaultSort: ['estimated_bill_date', 'asc'],
                    perPage: 10,
                    perPageOptions: [5, 10, 15, 25, 50],
                },
                tableName: 'services-upcoming',
                urlFilter: { enabled: false },
                viewAll: false,
            }
        },

        getNode() { return this.$refs.container },

        methods: {
            ...mapActions([
                'approveProjectService',
                'billProjectService',
                'billProjectServices',
                'partialUpdateProjectService',
                'payProjectService',
                'updateCurrentUserServicesReminder',
                'updateCurrentUserServicesView',
            ]),

            fetchData(params) {
                const vm = this
                return axios.get(`/api/reports/services-upcoming-report`, { params })
                    .then(res => {
                        const { data } = res
                        if(data.pagination && vm.total !== data.pagination.total)
                            vm.total = data.pagination.total
                        this.items = res.data.data.map(i => ({
                            ...i,
                            final_price: this.$filters.currency(i.final_price),
                            final_price_value: i.final_price
                        }))
                        const notesHistoryArray = res.data.data.notes_history || []
                        vm.notesHistory = notesHistoryArray.reduce((obj, item) => {
                            const serviceNotesArray = obj[item.reference_id] || []
                            serviceNotesArray.push(item)
                            obj[item.reference_id] = serviceNotesArray
                            return obj
                        }, {})
                        this.total = res.data.data.length
                        return { data: res.data}
                    })
            },

            handleCustomViewDeleted() {
                this.filters.table_view_id = null
                this.updateCurrentUserServicesView({ services_view: null })
                this.fetchPaginatedData(true)
            },

            handleCustomViewChange(services_view) {
                this.filters.table_view_id = services_view
                this.updateCurrentUserServicesView({ services_view })
                this.fetchPaginatedData(true)
            },

            handleEstimatedBillDateUpdated() {
                this.fetchPaginatedData()
            },

            handleServicesReminderChange(services_reminder) {
                this.updateCurrentUserServicesReminder({ services_reminder }).then(()=> {
                    this.successMessage('Reporting frequency updated')
                })
            },

            handleStatusUpdate(item) {
                const update = () => this.partialUpdateProjectService(item).then(res => {
                    const data = res.data.data,
                    changeOrder = data['change-order']
                    if( item.status === 'dropped' && changeOrder) {
                        const project = this.project
                        const to = { name: 'change-orders.edit', params: { slug: changeOrder.id, project, proposal: changeOrder, changeOrder } }
                        this.$router.push(to)
                    }
                    this.$forceUpdate()
                    item.status = res.data.data.status
                    return res
                }, r => Promise.reject(r))
                if(item.status === 'dropped'){
                    return this.confirmMessage(
                        'Are you sure?',
                        'This action cannot be undone.',
                        'Yes'
                    ).then(update, r => Promise.reject(r))
                }
                return update()
            },

            invalidEstimatedDates() {
                return this.projectServices.filter(p => this.isEstimatedBillDateInvalid(p));
            },

            isEstimatedBillDateInvalid(projectService) {
                return projectService.status === 'approved' && (!projectService.estimated_bill_date || ( new Date(`${projectService.estimated_bill_date} `) < new Date(new Date().toLocaleDateString()) ));
            },

            isStatusDisabled(projectService) {
                return projectService.status === 'dropped' || this.isEstimatedBillDateInvalid(projectService)
            },

            itemsByIds() {
                return this.items
            },

            openEstimatedBillDateModal(service) {
                this.currentService = service
                this.isEstimatedBillDateModalActive = true
            },

            openNotesHistoryModal(service) {
                this.currentService = service
                this.isNotesHistoryModalActive = true
            },

            setUserServicesConfiguration() {
                setTimeout(() => {
                  if (this.currentUser){
                    this.filters.table_view_id = this.currentUser.services_view
                    this.services_reminder = this.currentUser.services_reminder || ''
                  }
                }, 1000)
            },

            showNote(row) {
                return !!row && !!this.notesHistory[row.id];
            },
        },

        mounted() {
            this.fetchPaginatedData()
            this.setUserServicesConfiguration()
            if(this.shouldUserSelectServiceView) {
                this.confirmMessage('Custom view required', 'Please select or create a custom view to see your upcoming services').then(p => {
                    this.openCustomViewModal(null)
                });

            }
        },

        props: {
          filter: {
            type: Object,
            default () {
              return {
                allDates: false,
                converted_from: null,
                converted_to: null,
                exclude_services: [],
                from: null,
                projects: [],
                services: [],
                team_id: null,
                to: null,
                users: [],
              }
            },
          },
        },

        watch: {
            filter: {
                deep: true,
                handler:function (val) {
                  this.fetchPaginatedData(true, val)
                }
            },
        },
    }
</script>

<style lang="sass">
.services-upcoming-container
  overflow-x: hidden
  width: 100%
  .modal
    .modal-card
      margin: 0 auto
  .custom-view-select-container
    & > div:first-child
      flex-grow: 0
    & > div:nth-child(2)
      & > div
        & > div:first-child
          display: none
        & > div:last-child
          width: 33.33333333%
  .services-upcoming-table
    width: 100%
    td.notes ul > li
      text-align: justify
      white-space: nowrap
    .table-wrapper
      min-height: auto
      overflow-x: auto
      table
        white-space: nowrap
        th:not(:first-child)
          & > .th-wrap
            justify-content: center
        tbody > tr > td:not(:first-child)
          text-align: center
        tfoot
          tr
            th:not(:first-child)
              text-align: center
</style>